// removed by extract-text-webpack-plugin
module.exports = {"initialUtilityBar":"initial-utility-bar--33I9f","utilityBar":"utility-bar--2IaNh","heading":"heading--1Tee1","rightPane":"rightPane--2JAAX","leftPane":"leftPane--CEwyE","btnWrapper":"btn-wrapper--1t2IW","btnText":"btn-text--hBXcc","body":"body--3jSia","select":"select--rrCCy","escalationSelect":"escalation-select--1nvG2","memberTable":"member-table--11SVW","memberData":"member-data--2GO4y","levelWrapper":"level-wrapper--1gRC1","escalationWrapper":"escalation-wrapper--1nz41"};


//////////////////
// WEBPACK FOOTER
// ./app/components/containers/ticketing/resolverGroup/resolverGroup.scss
// module id = BPV5
// module chunks = 1